import AudioSource from '@/services/AudioSource';

export default class DefaultAudioNotifier {
  constructor(options) {
    this.options = options;
    this.initAudioContext();
  }

  initAudioContext() {
    const TargetAudioContext = window.AudioContext || window.webkitAudioContext;
    this.context = new TargetAudioContext();
  }

  playAudioSequence(audios) {
    return new Promise((resolve, reject) => {
      const audioSource = new AudioSource({
        context: this.context,
        urlList: audios
      });

      let successCallback = (audioSource) => {
        return audioSource.playAll();
      };
      
      const skipPlayAudioTimeout = setTimeout(() => {
        successCallback = () => {};
        reject();
      }, this.options.cancelAudioCallTicketTimeout * 1000);

      audioSource.loadAllSources()
        .then(() => {
          clearTimeout(skipPlayAudioTimeout);
          return successCallback(audioSource);
        })
        .catch((error) => reject(error))
        .then(resolve);
    });
  }
}
